module.exports = __webpack_public_path__ + "media/images/flags/32/New-Zealand-d8319c676b6be06fe94f68bf83c76a57.png";